import { ChangeDetectionStrategy, Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CallState } from '@lcs/shared/api';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { LcsDialogService } from 'src/app/common-components/dialog/dialog.service';
import { FormComponent } from 'src/app/common-components/forms-base/form-component.interface';
import { getExtensionGroupDetailsPrivileges } from 'src/app/privileges/privileges.selector';
import { getSelectedAccountId } from 'src/app/store/select-account/select-account.selector';
import { ExtensionDetailFormService } from '../../extension-details/services/extension-detail-form.service';
import { ExtensionGroupDetailView } from '../../extension-group-details/models/extension-group-detail-view.model';
import { ExtensionGroupDetailFormService } from '../../extension-group-details/services/extension-group-detail-form.service';
import { ExtensionGroupPrivileges } from '../../extension-groups-register/models/extension-group-privileges';
import { createExtensionGroup } from '../state/add-extension-group.actions';
import { getAddExtensionGroupCallState } from '../state/add-extension-group.selectors';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    providers: [ExtensionDetailFormService],
    selector: 'ndt-add-extension-group',
    styleUrls: ['./add-extension-group.component.scss'],
    templateUrl: './add-extension-group.component.html',
    standalone: false
})
export class AddExtensionGroupComponent implements OnInit, FormComponent {
   callState: Observable<CallState>;

   accountId: Observable<number | null>;

   extensionGroupPrivileges$: Observable<ExtensionGroupPrivileges>;

   form: UntypedFormGroup;

   get extensionGroup(): ExtensionGroupDetailView {
      return this._extensionGroup;
   }

   set extensionGroup(value: ExtensionGroupDetailView) {
      this._extensionGroup = value;
      if (value) {
         this.formService.updateExtensionGroup(value);
      }
   }

   private _extensionGroup: ExtensionGroupDetailView;

   constructor(
      protected store: Store,
      protected formService: ExtensionGroupDetailFormService,
      @Inject(MAT_DIALOG_DATA) public data,
      private dialogService: LcsDialogService
   ) {
      this.accountId = store.select(getSelectedAccountId);
      this.extensionGroup = {
         //LOOK AT SPREAD
         ...this.extensionGroup,
         extensionGroupId: 0,
      };
   }

   ngOnInit(): void {
      this.form = this.formService.form;
      this.callState = this.store.pipe(select(getAddExtensionGroupCallState));
      this.extensionGroupPrivileges$ = this.store.pipe(select(getExtensionGroupDetailsPrivileges));
   }

   onCloseClick(): void {
      this.dialogService.close();
   }

   onCreate(): void {
      if (this.form.valid) {
         const extensionGroup = this.formService.getValue(null);
         this.store.dispatch(
            createExtensionGroup({
               extensionGroupSave: {
                  extensionGroup: extensionGroup,
                  extensionGroupFields: [],
               },
            })
         );
      }
   }
}
